import SubjectsTable from "./SubjectTable";
import { useState, useEffect, useCallback } from "react";
import SubjectControl from "./SubjectControl";
import CreateSubjectModal from "./CreateSubjectModal";
import { subjectsApi } from "../../api/api";
import { simpleGetter } from "../../actions/common";
import { mapBackendToSubject } from "./subjectApiUtils";
import { Subject } from "./types";

export default function SubjectsPage() {
    const [year, setYear] = useState<string>("");
    const [semester, setSemester] = useState<"fall" | "spring" | "">("");
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [createSubjectModalOpen, setCreateSubjectModalOpen] = useState<boolean>(false);
    const [subjects, setSubjects] = useState<Subject[]>([]);
    const [loading, setLoading] = useState(true);

    const [sortBy, setSortBy] = useState<any>(undefined);
    const [sortDir, setSortDir] = useState<"asc" | "desc">("asc");

    const fetchSubjects = useCallback(async () => {
        setLoading(true);
        try {
            const res = await simpleGetter(subjectsApi.findAll, {});
            const list = res?.list ?? [];
            setSubjects(list.map(mapBackendToSubject));
        } catch (e) {
            console.error(e);
            setSubjects([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchSubjects();
    }, [fetchSubjects]);

    return (
        <div>
            <SubjectControl year={year} semester={semester} searchQuery={searchQuery} onYearChange={setYear} onSemesterChange={setSemester} onSearchChange={setSearchQuery} onCreate={() => setCreateSubjectModalOpen(true)} />
            <SubjectsTable
                data={subjects}
                searchQuery={searchQuery}
                sortBy={sortBy}
                sortDir={sortDir}
                loading={loading}
            />
            <CreateSubjectModal
                visible={createSubjectModalOpen}
                setVisible={setCreateSubjectModalOpen}
                subjectsList={subjects}
                onSuccess={fetchSubjects}
            />
        </div>
    );
}
